import React from "react"
import ComplainContainer from "../components/Complain/ComplainContainer"

function ComplainPage() {
  return <ComplainContainer />
}

export default ComplainPage
